const NoDataPlaceholder = () => (
  <span className="text-xs text-gray-400 whitespace-nowrap m-auto">
    Нет данных
  </span>
);

NoDataPlaceholder.displayName = "NoDataPlaceholder";
export default NoDataPlaceholder;
